<template>
  <div class="qtyButtons tours">
    <label>{{ title }}</label>
    <div class="plusminus horiz">
      <button class="minus" type="button" @click="decrement"></button>
      <input
        type="number"
        name="qtyInput_tours"
        v-model="value"
        :min="onMin"
        :max="onMax"
      />
      <button class="plus" type="button" @click="increment"></button>
    </div>
  </div>
</template>

<script>
export default {
  name: "pdk-qty",

  props: {
    title: {
      type: String,
      required: false,
    },
    min: {
      type: Number,
      required: true,
    },
    max: {
      type: Number,
      required: true,
    },
    default: {
      type: Number,
      required: false,
      default: 0,
    },
    canIncerement: {
      type: Boolean,
      default: true,
    },
    canDecrement: {
      type: Boolean,
      default: true,
    },
    step: {
      type: Number,
      default: 1,
    },
    controlType: {
      type: String,
    },
  },

  data: () => ({
    value: "",
  }),

  mounted: function () {
    this.value = this.default;
  },
  computed: {
    onMin() {
      return (this.min = this.min);
    },
    onMax() {
      return (this.max = this.max);
    },
    onDefault() {
      return (this.default = this.default);
    },
  },
  methods: {
    decrement: function () {
      if (!this.canDecrement) return;

      // 1400-04-21---  default value for adult in tourism from 0
      if (this.controlType === "tourism") {
        if (this.title !== "بزرگسال") {
          this.value = parseInt(this.value) - this.step;
          if (this.value < 0) {
            this.value = 0;
          }
          this.$emit("valueChange", this.value);
        } else {
          this.value = parseInt(this.value) - this.step;
          if (this.value < 0) {
            this.value = 0;
          }
          this.$emit("valueChange", this.value);
        }
      }
      //default value for adult in others from 1
      else {
        if (this.title !== "بزرگسال") {
          this.value = parseInt(this.value) - this.step;
          if (this.value < 0) {
            this.value = 0;
          }
          this.$emit("valueChange", this.value);
        } else {
          this.value = parseInt(this.value) - this.step;
          if (this.value < 1) {
            this.value = 1;
          }
          this.$emit("valueChange", this.value);
        }
      }
    },
    increment: function () {
      if (!this.canIncerement) return;
      this.value = parseInt(this.value) + this.step;
      this.$emit("valueChange", this.value);
    },
  },

  watch: {
    value: function (val) {
      // if (newValue > this.max || newValue < this.min) this.value = oldValue;

      this.$emit("valueChange", val);
    },
  },
};
</script>

<style lang="scss" scoped>
.plusminus {
  $size: 40px; //change this to change size of picker
  display: inline-block;
  position: relative;
  font-size: 0;
  overflow: hidden;
  border-radius: 20px;
  width: $size;
  height: ($size * 3);
  button {
    display: block;
    width: $size;
    height: $size;
    position: absolute;
    margin: 0;
    padding: 0;
    border: 0;
    color: #fff;
    font-size: ($size * 0.7);
    line-height: 1;
    font-family: bonds, sans-serif;
    cursor: pointer;
   
  }
  .minus{
      border-radius: 20px;
      background: #ff5874;
     &:focus {
      outline: none;
      color: #e7d3d7;
    }
    &:disabled {
      background: #999;
      color: #ccc;
      cursor: default;
    }
    &:first-child {
      bottom: 0;
      &:before {
        content: "-";
      }
    }
    &:last-child {
      top: 0;
      &:before {
        content: "+";
      }
      &:focus {
        color: #f3eaea;
      }
    }
  }
  .plus{
      border-radius: 20px;
      background: #00c3e1;
     &:focus {
      outline: none;
      color: #2bebaf;
    }
    &:disabled {
      background: #999;
      color: #ccc;
      cursor: default;
    }
    &:first-child {
      bottom: 0;
      &:before {
        content: "-";
      }
    }
    &:last-child {
      top: 0;
      &:before {
        content: "+";
      }
      &:focus {
        color: #dbf5f8;
      }
    }
  }
    
  input[type="number"] {
    position: absolute;
    width: $size;
    height: $size;
    top: $size;
    margin: 0;
    padding: 0 0 ($size/2.6);
    border: 0;
    font-size: ($size * 0.4);
    font-weight: bold;
    text-align: center;
    -moz-appearance: textfield;
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }

  &.horiz {
    width: ($size * 3);
    height: $size;
    button {
      &:first-child {
        left: 0;
      }
      &:last-child {
        right: 0;
      }
    }
    &:after {
      bottom: 0;
    }
    input[type="number"] {
      position: absolute;
      top: 0;
      left: $size;
      background: transparent !important;
    }
  }
  &.stacked {
    width: ($size * 2);
    height: ($size * 2);
    &:after {
      width: 100%;
      bottom: 50%;
    }
    button {
      float: none;
      top: auto;
      bottom: 0;
      &:first-child {
        left: 0;
      }
      &:last-child {
        right: 0;
      }
    }
    input[type="number"] {
      top: 0;
      border: 1px solid #eee;
      width: 100%;
      &:after {
        width: 100%;
      }
    }
  }
}
@media (max-width: 478px) {
  .plusminus {
    &.horiz {
      width: 84px;
      border-radius: 0;
    }
    input {
      width: 20px !important;
      font-size: 15px !important;
      top: 6px !important;
      left: 32px !important;
    }
    button {
      width: 30px;
      height: 30px;
      font-size: 20px;
      top: 10px !important;
      .btn-decrement {
        left: 3px;
      }
      .btn-imcrement {
        right: 3px;
      }
    }
  }
}
</style>